export default __webpack_public_path__ + "static/media/video-2.a6c8fa9e.mov";